var $d5ab76bcbadc9c07$exports = {};
$d5ab76bcbadc9c07$exports = {
  "breadcrumbs": "S\xF6kv\xE4gar"
};
export { $d5ab76bcbadc9c07$exports as default };